import React from 'react';
import type { CatalogItem } from '../../services/restaurantService';
import './Catalog.css';

interface CatalogLandscapeBannerProps {
  item?: CatalogItem | null;
  title?: string;
  subtitle?: string;
}

const CatalogLandscapeBanner: React.FC<CatalogLandscapeBannerProps> = ({
  item,
  title,
  subtitle,
}) => {
  const label = item ? (item.name || item.type || '') : title || '';
  const bannerUrl = item?.landscapeBannerUrl || item?.portraitBannerUrl;
  const initial = label ? label.charAt(0).toUpperCase() : '';

  if (!label && !bannerUrl) {
    return null;
  }

  return (
    <div
      className={`catalog-landscape-banner${bannerUrl ? '' : ' catalog-landscape-banner--placeholder'}`}
      style={bannerUrl ? { backgroundImage: `url(${bannerUrl})` } : undefined}
      role="img"
      aria-label={label}
    >
      <div className="catalog-landscape-banner__overlay">
        <div className="catalog-landscape-banner__text">
          {!bannerUrl && initial && (
            <span className="catalog-landscape-banner__initial">{initial}</span>
          )}
          <h2 className="catalog-landscape-banner__title">{title || label}</h2>
          {subtitle && <p className="catalog-landscape-banner__subtitle">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default CatalogLandscapeBanner;
